module.exports = __webpack_public_path__ + "static/media/sold_out_sm.b4a96e04.svg";